import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import type { TenantMe } from '../types'

export function useQueryTenantMe() {
  return useQuery<TenantMe | null>({
    queryKey: ['tenant.me'],
    queryFn: async () => {
      try {
        const { data } = await axiosInstance.get<TenantMe>('/config-api/tenant/me')
        return data
      } catch (e: any) {
        if (e?.response?.status === 404) return null
        throw e
      }
    },
    staleTime: 60_000,
  })
}
